import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import type { AspectRatio } from '../components/DynamicMediaItem';

export const SCREEN_BIGMOBILE = 480;
export const SCREEN_NORMAL = 768;
export const SCREEN_WIDE = 1024;


type AspectRatioMap = {
  small: AspectRatio
  medium: AspectRatio;
  large: AspectRatio;
  xlarge: AspectRatio;
};

export function resolveAspectRatio(width: number, map: AspectRatioMap): AspectRatio {
  if (width < SCREEN_BIGMOBILE) return map.small;
  if (width < SCREEN_NORMAL) return map.medium;
  if (width < SCREEN_WIDE) return map.large;
  return map.xlarge;
}

export function useAspectRatio(map: AspectRatioMap): AspectRatio {
  const { width } = useWindowDimensions();
  return resolveAspectRatio(width, map);
}
